import { useRoute, useRouter } from 'vue-router'
import {
  getQueriesFromRoute,
  getQueriesInPreDefinedFormat,
} from '~/utils/product-filter/filter-helpers'
import type { LocationQueryRaw } from 'vue-router'

type QueryParams = { [key: string]: string | number }

export default function useProductListingSortRoutes() {
  const route = useRoute()
  const router = useRouter()

  const isValidValue = (value: string | number | null | undefined): boolean =>
    !!value

  const convertParamsToString = (params: QueryParams) =>
    Object.keys(params).reduce(
      (acc, key) => {
        acc[key] = params[key].toString()
        return acc
      },
      {} as { [key: string]: string }
    )

  const buildQueryObject = (params: QueryParams) => {
    const currentRouteQueries = getQueriesFromRoute(route.query)
    const updatedParams = convertParamsToString(params)

    const mergedParams = {
      ...currentRouteQueries,
      ...updatedParams,
    }

    const sortedQuery = getQueriesInPreDefinedFormat(mergedParams)

    return Object.entries(sortedQuery).reduce(
      (query: LocationQueryRaw, [key, value]) => {
        if (isValidValue(value)) query[key] = value
        return query
      },
      {} as LocationQueryRaw
    )
  }

  const sortAndBuildUrlQuery = (params: QueryParams) => {
    const newQuery = buildQueryObject(params)

    if (isValidValue(params.page)) {
      newQuery['page'] = params.page.toString()
    }

    router.push({ query: newQuery })
  }

  return {
    sortAndBuildUrlQuery,
  }
}
